import Notice from "@web-ui/components/Notice";

/** What sample data is, said the same way by the banner (Analytics) and the chip (Home). */
export const SAMPLE_EXPLANATION = "These numbers are generated examples, so you can see how the screens work. They are replaced by real viewing once the sample is cleared.";

/** Shown whenever any answer on the screen holds generated sample data (docs/analytics.md §7). */
export function SampleNotice({ shown }: { shown: boolean }) {
  if (!shown) return null;
  return (
    <Notice tone="info" title="Sample data">
      {SAMPLE_EXPLANATION}
    </Notice>
  );
}
